import React from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { isEqual } from "lodash";
import { AiOutlineArrowUp, AiOutlineArrowDown } from "react-icons/ai";
import { RootState } from "../../../state";
import { getPreferredFormattedTimeMs } from "../../../utils/preferences";

export default function Leaderboard() {
  const driverInfo = useSelector(
    (state: RootState) => state.imports.derivedImportData.strategy.driverInfo,
    isEqual,
  );

  const entry = useSelector(
    (state: RootState) => state.aks.v2.timing?.session?.entry,
    isEqual,
  );

  const standings =
    useSelector(
      (state: RootState) =>
        state.aks.v2.timing?.session?.standings?.overall?.active,
      isEqual,
    ) || {};

  const participantDetails =
    useSelector(
      (state: RootState) =>
        state.aks.v2.timing?.session?.standings?.overall?.participantDetails,
      isEqual,
    ) || {};

  const sessionType = useSelector(
    (state: RootState) => state.aks.v2.timing?.session?.info?.type,
  );

  // const attackMode =
  //   useSelector((state: RootState) => state.aks.v2.attackMode, isEqual) || {};

  const standingsArray = Object.keys(standings)
    .map(Number)
    .sort((a, b) => a - b)
    .map((key) => standings[`${key}`]);

  return (
    <div className={styles.leaderboard}>
      <table>
        <thead>
          <tr className={styles.titleRow}>
            <th colSpan={8}>Overall Leaderboard</th>
          </tr>
          <tr>
            <th className={styles.tableIconsHeader}></th>
            <th>Pos</th>
            {/* <>Num</ th> */}
            <th>Driver</th>
            <th>Lap</th>
            <th>Best</th>
            <th>Last</th>
            <th>Gap</th>
            <th>Int</th>
          </tr>
        </thead>
        <tbody>
          {standingsArray.map((standings, key) => {
            if (standings) {
              const driverNum = standings.participant as keyof typeof entry;
              const driverName = entry?.[driverNum]?.drivers?.["1"]?.shortName;
              // const inAttack = attackMode?.[driverNum]?.active || false;
              const hasSeenCheckered =
                participantDetails?.[driverNum]?.hasSeenCheckered || false;
              const bestLapTime =
                participantDetails?.[driverNum]?.bestLap?.time;
              const lastLapTime =
                participantDetails?.[driverNum]?.lastLap?.time;
              const currentLap = participantDetails?.[driverNum]?.currentLap;
              const status = participantDetails?.[driverNum]?.status;
              const driverInfoEntry = driverInfo?.[driverNum];
              const style = {
                color: driverInfoEntry?.driverFontColour || "black",
                backgroundColor: driverInfoEntry?.driverTeamColour || "white",
                opacity: status === "STOPPED" ? 0.25 : 1,
              };
              return (
                <tr key={key} style={style}>
                  <td className={styles.tableIcons}>
                    {hasSeenCheckered ? (
                      <div className={styles.hasSeenCheckered}></div>
                    ) : status === "BOX" ? (
                      <div className={styles.pitIcon}>P</div>
                    ) : (standings.positionChange || 0) <= -1 &&
                      sessionType === "RACE" ? (
                      <AiOutlineArrowUp
                        className={styles.positionGained}
                      ></AiOutlineArrowUp>
                    ) : (standings.positionChange || 0) >= 1 &&
                      sessionType === "RACE" ? (
                      <AiOutlineArrowDown
                        className={styles.positionLost}
                      ></AiOutlineArrowDown>
                    ) : (
                      <></>
                    )}
                  </td>
                  <td>{standings.position}</td>
                  <td>{driverName}</td>
                  <td>{currentLap}</td>
                  <td>
                    {bestLapTime
                      ? getPreferredFormattedTimeMs(bestLapTime)
                      : "-"}
                  </td>
                  <td>
                    {lastLapTime
                      ? getPreferredFormattedTimeMs(lastLapTime)
                      : "-"}
                  </td>
                  <td>
                    {standings.gapFirstTime ? standings.gapFirstTime / 1000 : 0}
                  </td>
                  <td>
                    {standings.gapPreviousTime
                      ? standings.gapPreviousTime / 1000
                      : 0}
                  </td>
                </tr>
              );
            } else {
              return <></>;
            }
          })}
        </tbody>
      </table>
    </div>
  );
}
